/**
 * tel: link of a displayed phone number - "+49 (0)5231 7090 13 00" dials as "+49523170901300", without
 * the "(0)", spaces and dashes.
 */
const getPhoneHref = (number: string): string => `tel:${number.replace(/\(0\)/g, '').replace(/[^\d+]/g, '')}`

export default getPhoneHref
